exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\n  display: block;\n  height: 15rem; }\n  :host .preview {\n    width: 100%;\n    height: 100%;\n    background-size: cover;\n    background-position: center;\n    background-repeat: no-repeat;\n    background-color: #777;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-align: end;\n        align-items: flex-end; }\n    :host .preview.contain {\n      background-size: contain; }\n    :host .preview button {\n      -ms-flex: 1;\n          flex: 1;\n      -ms-flex-positive: 1;\n          flex-grow: 1;\n      border-radius: 0;\n      margin: 0;\n      background-color: rgba(255, 255, 255, 0.8);\n      -ms-flex-pack: center;\n          justify-content: center; }\n      :host .preview button:hover {\n        background-color: rgba(255, 255, 255, 0.9); }\n  :host input[type='file'] {\n    display: none; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/axel/Sites/Bannerboy/Internal/attaboy-angular/src/app/ui-shared/image-input/image-input.component.scss
// module id = ../../../../../src/app/ui-shared/image-input/image-input.component.scss
// module chunks = main